<!-- assets/components/Client/ManualCenterView.vue -->

<template>
  <Paper>
    <h2 class="text-2xl text-cal-009588 mb-4">Manuals</h2>
    <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 lg:gap-8">
      <div v-for="manual in manuals" :key="manual.id" class="shadow-sm border border-gray-50 hover:ring ring-cal-blue ring-offset-2 cursor-pointer bg-cal-F4F2F2 flex flex-col group relative">
        <img :src="manual.acf.gated_content_thumbnail" />
        <div class="p-4 flex-grow">
          <div class="text-cal-light-blue group-hover:text-cal-blue text-xl font-bold mb-2">{{manual.title.rendered}}</div>
          <div v-html="manual.excerpt.rendered"></div>
          <div class="mt-4">
            <a target="_blank" :href="manual.acf.gated_content_pdf" class="bg-cal-81B920 hover:bg-cal-green text-white uppercase px-4 py-2 text-sm">
              <span aria-hidden="true" class="absolute inset-0"></span>
              View
            </a>
          </div>
        </div>
      </div>
    </div>
  </Paper>
</template>

<script>

import Paper from '../Layout/Paper.vue'
import ColumnView from '../Shared/ColumnView.vue';
import VueButton from '../Shared/VueButton.vue';
import VueModal from '../Shared/VueModal.vue';
import VueForm from '../Shared/VueForm.vue';

export default {
  components: {Paper },
  data() {
    return {
      manuals: [],
    }
  },
  created() {
    this.$http
        .get('https://www.constructalead.com/wp-json/wp/v2/training-manual')
        .then(response => this.manuals = response.data)
  },
}

</script>
